






























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { doublePrevention } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
  filters: {},
})
export default class DetailPage extends Vue {
  @Prop(Object) rowData: any;
  private formData: any = {};

  private technologyMeasureHazardList: any = [];
  private controlMeasuresHazardList: any = [];
  private individualProtectShowHazardList: any = [];
  private trainingAndEducationalMeasuresHazardList: any = [];
  private emergencyTreatmentMeasuresHazardList: any = [];

  created() {
    this.getRiskControlInventoryDetail();
  }

  // 详情
  private getRiskControlInventoryDetail() {
    doublePrevention.getRiskControlInventoryDetail(this.rowData.id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;

        this.technologyMeasureHazardList = res.data.technologyMeasureHazardList;
        this.controlMeasuresHazardList = res.data.controlMeasuresHazardList;
        this.individualProtectShowHazardList = res.data.individualProtectShowHazardList;
        this.trainingAndEducationalMeasuresHazardList = res.data.trainingAndEducationalMeasuresHazardList;
        this.emergencyTreatmentMeasuresHazardList = res.data.emergencyTreatmentMeasuresHazardList;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private backClose() {
    this.$emit('closePage');
  }
}
